import { NavigationRoute } from 'react-navigation';
import { NavStateEnum } from './types';

export const NAVIGATION_STATE_CHANGE = 'NAVIGATION.NAVIGATION_STATE_CHANGE';
export const NAVIGATION_WEB_STATE_CHANGE = 'NAVIGATION.NAVIGATION_WEB_STATE_CHANGE';
export const NAVIGATION_BREAD_CRUMB = 'NAVIGATION_BREAD_CRUMB';

export const navigationStateChange = (
  currentState: NavigationRoute,
  previousState?: NavigationRoute
) => ({
  type: NAVIGATION_STATE_CHANGE,
  payload: {
    previousState,
    currentState
  }
});

export const navigationBreadCrumb = (breadCrumb: string) => ({
  type: NAVIGATION_BREAD_CRUMB,
  payload: {
    breadCrumb
  }
});

export const navigationWebStateChange = (webState: NavStateEnum) => ({
  type: NAVIGATION_WEB_STATE_CHANGE,
  payload: {
    webState
  }
});
